import React from "react"
import Icon from "../../../components/AppIcon"

const ComingSoonPanel = ({ label }) => {
  return (
    <div className="bg-card border border-border rounded-xl p-12 text-center">
      <div className="w-14 h-14 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
        <Icon name="Hammer" size={24} className="text-accent" />
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-1">{label}</h3>
      <p className="text-muted-foreground text-sm">This section is being built. Check back soon.</p>
    </div>
  )
}

export default ComingSoonPanel